import React from 'react';
import { upperFirst } from 'lodash';

import NotificationContent from '../../shared/AppointmentContainer';
import Header from './components/Header';
import Footer from '../../shared/Footer';
import Logo from '../../shared/Logo';
import AppointmentInfo from '../../shared/AppointmentInfo';
import ShopLocation from '../../shared/ShopLocation';
import PhonesBackground from '../../shared/PhonesBackground';
import SquireInfo from '../../shared/SquireInfo';
import PostCtaAction from './components/PostCtaAction';
import Cta from './components/Cta';
import withWaitingListNotification from '../../hoc/withWaitingListNotification';

/* eslint-disable react/prop-types */
const CustomerWaitingListPurged = ({
  shop,
  customer,
  barber,
  service,
  address,
  duration,
  appLink,
  squireInfoClassName,
}) => (
  <div>
    <Header shopName={shop.name} customerName={upperFirst(customer.firstName)} />
    <NotificationContent>
      <Logo />
      <h2 className="u-text-huge u-fw-bold u-mt-10 u-mb-10">
        Hey {upperFirst(customer.firstName)},
        you didn&apos;t make it today so we removed you. Try again.
      </h2>
      <div className="u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4">
        Waiting list
      </div>
      <div className="u-flex u-justify-content-space-between u-flex-wrap">
        <AppointmentInfo
          waitingList
          barberName={`${barber.firstName} ${(barber.lastName || '')[0]}.`}
          service={service}
          duration={duration}
        >
          <a className="c-book-again-button u-co-white u-mt-8 u-text-medium" href={appLink} target="_blank">
            Book again
          </a>
        </AppointmentInfo>
        <div className="c-appointment-info-divider u-hide-on-desktop" />
        <ShopLocation
          shopName={shop.name}
          phone={shop.phone}
          line1={address.line1}
          line2={address.line2}
          map={shop.staticMap.url}
          directions={address.directions}
        />
      </div>
      { shop.mobileAppCta && <Cta appLink={appLink} /> }
      { shop.mobileAppCta && <PhonesBackground name="rebook" /> }
      <div className={squireInfoClassName}>
        <SquireInfo
          standalone={!shop.mobileAppCta}
          shopName={shop.name}
          renderAction={PostCtaAction}
        />
      </div>
    </NotificationContent>
    <Footer link={appLink} />
  </div>
);

export default withWaitingListNotification(CustomerWaitingListPurged);



// WEBPACK FOOTER //
// ./src/app/notifications/customer/CustomerWaitingListPurged/index.jsx